import { FaCaretRight } from "react-icons/fa";

import { cn } from "@bentolabs/kit/utils";

import WasabiLogo from "shared/assets/wasabi-logo.svg?react";
import { Button } from "shared/ui/button";

type Props = {
  className?: string;
};

export const Hero = (props: Props) => {
  const { className } = props;

  return (
    <section
      className={cn("mx-auto flex flex-col items-center px-4", className)}
    >
      <div className="flex gap-x-1.5">
        <div
          className={cn(
            "green-gradient relative inline-flex items-center justify-center",
            "size-12 rounded-md rounded-tl-2xl rounded-bl-2xl p-1.5 pr-1.5",
            "md:size-20 md:rounded-[10px] md:rounded-tl-3xl md:rounded-bl-3xl"
          )}
        >
          <WasabiLogo className="text-spearmint inline-flex size-8.5 md:size-14" />
        </div>
        <span
          className={cn(
            "text-spearmint green-gradient inline-flex",
            "rounded-md rounded-tr-2xl rounded-br-2xl pt-2 pr-2.5 pb-1 pl-2 text-[38px] leading-none",
            "md:rounded-[10px] md:rounded-tr-3xl md:rounded-br-3xl md:pt-3 md:pr-4 md:pb-1.5 md:pl-3.5 md:text-6xl"
          )}
        >
          WASABI
        </span>
      </div>
      <h1 className="mt-1.5 text-center text-[44px] leading-[105%] md:text-7xl">
        Farming Season&nbsp;0
      </h1>
      <p className="text-nobel mt-6 text-center leading-[150%] whitespace-pre-line md:text-lg">
        {
          "Pre-deposit your favourite stable coins\nto earn WASABI points and boosted yields"
        }
      </p>

      <Button className="mt-8 w-44 justify-start">
        Learn more
        <Button.Icon>
          <FaCaretRight />
        </Button.Icon>
      </Button>
    </section>
  );
};
